module.exports = __webpack_public_path__ + "static/media/sws-icon.b25ddce9.svg";